import { useQuery } from '@apollo/client';
import { graphql } from 'gql.tada';

const FamiliesForEnrollmentQuery = graphql.persisted(
  "FamiliesForEnrollmentQuery",
  graphql(`
    query FamiliesForEnrollmentQuery($schoolId: ID!, $schoolYearId: ID!) {
      school(id: $schoolId) {
        id
        families {
          id
          name
          slug
          primaryContactEmail
          children {
            id
            person {
              id
              firstName
              lastName
              dateOfBirth
            }
          }
        }
      }
      schoolYear(id: $schoolYearId) {
        id
        studentEnrollments {
          id
          person {
            id
          }
        }
        familyEnrollments {
          id
          family {
            id
          }
        }
        previousYear {
          id
          studentEnrollments {
            id
            gradeLevel
            person {
              id
            }
          }
        }
      }
    }
  `)
);

export { FamiliesForEnrollmentQuery };

export function useFamiliesForEnrollmentQuery(
  schoolId: string | undefined,
  schoolYearId: string | undefined,
  skip?: boolean
) {
  return useQuery(FamiliesForEnrollmentQuery, {
    variables: { schoolId: schoolId!, schoolYearId: schoolYearId! },
    skip: skip || !schoolId || !schoolYearId,
  });
}
